export default class AnswerResponse {
  id: string;

  questionId: string;

  questionPosition: number;

  questionType: string;

  questionTitle: string;

  questionPersonalityFactorName: string;

  answerValue: string;

  choiceValue: number;

  correctAnswer: string;

  isCorrect: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.questionId = obj.questionId || '';
    this.questionPosition = obj.questionPosition || 0;
    this.questionType = obj.questionType || '';
    this.questionPersonalityFactorName = obj.questionPersonalityFactorName || '';
    this.questionTitle = obj.questionTitle || '';
    this.answerValue = obj.answerValue || '';
    this.choiceValue = obj.choiceValue || 0;
    this.correctAnswer = obj.correctAnswer || '';
    this.isCorrect = obj.isCorrect || null;
  }
}
